import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=dbc26cda&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=dbc26cda&prod&lang=scss"
import style1 from "./Pricing.vue?vue&type=style&index=1&id=dbc26cda&prod&lang=scss&scoped=true"
import style2 from "./Pricing.vue?vue&type=style&index=2&id=dbc26cda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc26cda",
  null
  
)

export default component.exports